import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-600" }, "Celkem včetně DPH: ", -1)
const _hoisted_4 = { class: "text-900 font-medium text-xl mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-600" }, "Celkem bez DPH: ", -1)
const _hoisted_6 = { class: "text-900 font-medium text-xl mb-2" }
const _hoisted_7 = { class: "col-2 text-right" }

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {computed} from "vue";
import {InvoicePreview} from "@/components/blocks/Types";
import {formatPrice} from "@/services/FormatService";
import Panel from "primevue/panel";
import Button from "primevue/button";

// Define types
interface Properties {
    invoices: InvoicePreview[],
}

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceListPreview',
  props: {
    invoices: null
  },
  emits: ['GenerateBulkRequest'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    invoices: InvoicePreview[],
};




const totalWithoutVat = computed(() => {
    if (props.invoices.length > 0) {
        return formatPrice(props.invoices.reduce((curr, acc) => acc["paymentSumWithoutVat"] + curr, 0))
    } else {
        return 0
    }
})

const totalWithVat = computed(() => {
    if (props.invoices.length > 0) {
        return formatPrice(props.invoices.reduce((curr, acc) => acc["paymentSum"] + curr, 0))
    } else {
        return 0
    }
})


function generateBulk() {
    emits('GenerateBulkRequest');
}


return (_ctx: any,_cache: any) => {
  return (props.invoices.length>0)
    ? (_openBlock(), _createBlock(_unref(Panel), {
        key: 0,
        header: "Balance Overview",
        class: "mt-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DataTable), {
            headerStyle: "color:red !important",
            ref: "dt",
            dataKey: "id",
            value: props.invoices,
            paginator: false,
            rowHover: true,
            totalRecords: props.invoices.length
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Column), {
                field: "invoiceNumber",
                header: "Číslo faktury"
              }),
              _createVNode(_unref(Column), { header: "Vydal" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(data.issuer.companyName), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), { header: "Příjemce" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(data.recipient.companyName), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), { header: "Částka" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(_unref(formatPrice)(data.paymentSumWithoutVat)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), { header: "Částka vč. DPH" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(_unref(formatPrice)(data.paymentSum)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "totalRecords"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _hoisted_3,
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(totalWithVat)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(totalWithoutVat)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(Button), {
                onClick: generateBulk,
                icon: "pi pi-download",
                label: "Generovat zip"
              })
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})